import { useState } from 'react';
import Navbar from '../components/Navbar';
import Sidebar from '../components/Sidebar';
import Feed from '../components/Feed';
import RightSidebar from '../components/RightSidebar';
import StoriesBar from '../components/StoriesBar';
import CreatePost from '../components/CreatePost';
import { Plus } from 'lucide-react';

const Home = () => {
  const [showCreatePost, setShowCreatePost] = useState(false);
  const [feedKey, setFeedKey] = useState(0);

  const handlePostCreated = () => {
    setFeedKey(prev => prev + 1);
  };

  return (
    <div className="min-h-screen bg-background pb-20 md:pb-0">
      <Navbar />
      <div className="max-w-7xl mx-auto px-4 pt-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {/* Left Sidebar */}
          <div className="hidden lg:block lg:col-span-3">
            <div className="sticky top-24">
              <Sidebar />
            </div>
          </div>

          {/* Main Feed */}
          <div className="lg:col-span-6">
            <StoriesBar />
            <div className="mt-6 hidden md:block">
              <button
                onClick={() => setShowCreatePost(true)}
                className="w-full bg-card rounded-2xl p-4 shadow-sm hover:shadow-md transition-all cursor-pointer border-0"
              >
                <p className="text-muted-foreground text-left text-[15px]">What's on your mind?</p>
              </button>
            </div>
            <div className="mt-6">
              <Feed key={feedKey} />
            </div>
          </div>

          {/* Right Sidebar */}
          <div className="hidden lg:block lg:col-span-3">
            <div className="sticky top-24">
              <RightSidebar />
            </div>
          </div>
        </div>
      </div>

      {/* Floating Create Post Button — mobile only */}
      <button
        onClick={() => setShowCreatePost(true)}
        className="fixed right-14 bottom-[76px] z-50 md:hidden w-11 h-11 rounded-full bg-primary text-white shadow-xl flex items-center justify-center active:scale-90 transition-transform hover:shadow-2xl"
        data-testid="floating-create-post-btn"
        aria-label="Create post"
      >
        <Plus className="w-5 h-5" strokeWidth={2.5} />
      </button>

      {showCreatePost && (
        <CreatePost 
          onClose={() => setShowCreatePost(false)}
          onPostCreated={handlePostCreated}
        />
      )}
    </div>
  );
};

export default Home;
